import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidRestaurantIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16.8 11.6c.8 0 1.6-.3 2.1-.9l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-2.8 2.8c-.4.4-1 .4-1.4 0l3.5-3.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.5 3.5c-.4-.4-.4-1 0-1.4l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-2.8 2.8c-1.2 1.2-1.2 3.1 0 4.2L12 10.6 3.7 2.3c-.4-.4-1-.4-1.4 0l-.3.6c-.5 3.4.7 6.9 3.1 9.3l2.6 2.6-5.4 5.4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l10.9-10.9c.7.6 1.4.9 2.2.9ZM15.4 14c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6.3 6.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L15.4 14Z"/>
  </SvgIcon>
}

export default SolidRestaurantIcon
